var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "135px",
    height: "135px",
    viewBox: "0 0 135 135",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#B2E4C1",
    cx: 67.5,
    cy: 67.5,
    r: 67.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26, 26)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41,0 C63.6714542,0 82,18.3285458 82,41 C82,63.6714542 63.6714542,82 41,82 C18.3285458,82 0,63.6714542 0,41 C0,18.3285458 18.3285458,0 41,0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M88.1075829,64.6666666 L45.2438062,64.6666666 C43.3538946,64.6684273 41.7926838,65.9062981 41.6819263,67.490851 C41.5711688,69.075404 42.9491998,70.458194 44.8258844,70.6456666 L45.2438062,70.6666666 L88.1075829,70.6666666 C89.9974945,70.6649059 91.5587053,69.4270351 91.6694628,67.8424822 C91.7802204,66.2579292 90.4021893,64.8751392 88.5255047,64.6876666 L88.1075829,64.6666666 Z",
    fill: "#B2E4C1",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactive);
export default __webpack_public_path__ + "static/media/inactive.9deb6b234884b8bbee65447933012554.svg";
export { ForwardRef as ReactComponent };